import * as actionTypes from '../actions/actionTypes';

export default function (state = [], action) {
  switch (action.type) {
    case actionTypes.FETCH_COUNTRIES_SUCCESS:
      return [...action.countries];
    default:
      return state;
  }
}
